webpackJsonp([79611799117203,60335399758886],{

/***/ 168:
/***/ (function(module, exports) {

	module.exports = {"layoutContext":{}}

/***/ }),

/***/ 299:
/***/ (function(module, exports, __webpack_require__) {

	"use strict";
	
	exports.__esModule = true;
	
	var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };
	
	var _react = __webpack_require__(2);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _index = __webpack_require__(304);
	
	var _index2 = _interopRequireDefault(_index);
	
	var _layoutIndex = __webpack_require__(168);
	
	var _layoutIndex2 = _interopRequireDefault(_layoutIndex);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	exports.default = function (props) {
	  return _react2.default.createElement(_index2.default, _extends({}, props, _layoutIndex2.default));
	};
	
	module.exports = exports["default"];

/***/ }),

/***/ 302:
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	exports.__esModule = true;
	
	var _react = __webpack_require__(2);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _gatsbyLink = __webpack_require__(164);
	
	var _gatsbyLink2 = _interopRequireDefault(_gatsbyLink);
	
	var _github = __webpack_require__(615);
	
	var _github2 = _interopRequireDefault(_github);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function Footer() {
	  return _react2.default.createElement(
	    'footer',
	    { className: 'ph3 ph4-ns pt6 pb3' },
	    _react2.default.createElement(
	      'a',
	      { className: 'link b f3 dim black-70 lh-solid', href: 'mailto:hello@christhierer.com' },
	      'hello@christhierer.com'
	    ),
	    _react2.default.createElement(
	      'p',
	      { className: 'f6 db ttu lh-solid pt1' },
	      _react2.default.createElement(
	        'span',
	        { role: 'img', 'aria-label': 'Copyright' },
	        '\xA9'
	      ),
	      ' 2018 Chris Thierer'
	    ),
	    _react2.default.createElement(
	      'div',
	      { className: 'mt3' },
	      _react2.default.createElement(
	        _gatsbyLink2.default,
	        { className: 'f6 dib pr2 mid-gray dim', to: '/' },
	        'Home'
	      ),
	      _react2.default.createElement(
	        'a',
	        { className: 'f6 dib ph2 mid-gray dim', href: 'https://www.christhierer.com' },
	        'Portfolio'
	      ),
	      _react2.default.createElement(
	        'a',
	        { className: 'f6 dib pl2 mid-gray dim', href: 'https://www.christhierer.com/resume' },
	        'R\xE9sum\xE9'
	      )
	    ),
	    _react2.default.createElement(
	      'a',
	      { className: 'mt4 db', href: 'https://github.com/cthierer/notebook' },
	      _react2.default.createElement('img', { className: 'mb0', src: _github2.default, alt: 'GitHub logo' })
	    )
	  );
	}
	
	exports.default = Footer;
	module.exports = exports['default'];

/***/ }),

/***/ 303:
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	exports.__esModule = true;
	
	var _react = __webpack_require__(2);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _gatsbyLink = __webpack_require__(164);
	
	var _gatsbyLink2 = _interopRequireDefault(_gatsbyLink);
	
	var _NavBarModule = __webpack_require__(392);
	
	var _NavBarModule2 = _interopRequireDefault(_NavBarModule);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function NavBar() {
	  var _ref = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {},
	      _ref$linkable = _ref.linkable,
	      linkable = _ref$linkable === undefined ? false : _ref$linkable;
	
	  return _react2.default.createElement(
	    'nav',
	    { className: 'pv3', style: { backgroundColor: '#0F0B0C' } },
	    _react2.default.createElement(
	      'h1',
	      { className: 'ph3 ph4-ns db mv0 ttl', style: { color: '#E8E8E8' } },
	      linkable ? _react2.default.createElement(
	        _gatsbyLink2.default,
	        { className: _NavBarModule2.default.title, style: { color: '#E8E8E8' }, to: '/' },
	        'Notebook'
	      ) : 'Notebook'
	    )
	  );
	}
	
	exports.default = NavBar;
	module.exports = exports['default'];

/***/ }),

/***/ 392:
/***/ (function(module, exports) {

	// removed by extract-text-webpack-plugin
	module.exports = {"title":"src-components----NavBar-module---title---2URWo"};

/***/ }),

/***/ 615:
/***/ (function(module, exports) {

	module.exports = "data:image/svg+xml;base64,PCEtLT94bWwgdmVyc2lvbj0iMS4wIiBlbmNvZGluZz0iVVRGLTgiIHN0YW5kYWxvbmU9Im5vIj8tLT4KPHN2ZyB4bWxuczpkYz0iaHR0cDovL3B1cmwub3JnL2RjL2VsZW1lbnRzLzEuMS8iIHhtbG5zOmNjPSJodHRwOi8vY3JlYXRpdmVjb21tb25zLm9yZy9ucyMiIHhtbG5zOnJkZj0iaHR0cDovL3d3dy53My5vcmcvMTk5OS8wMi8yMi1yZGYtc3ludGF4LW5zIyIgeG1sbnM6c3ZnPSJodHRwOi8vd3d3LnczLm9yZy8yMDAwL3N2ZyIgeG1sbnM9Imh0dHA6Ly93d3cudzMub3JnLzIwMDAvc3ZnIiB3aWR0aD0iMzJweCIgaGVpZ2h0PSIzMnB4IiBjbGFzcz0ib2N0aWNvbiBvY3RpY29uLW1hcmstZ2l0aHViIiB2aWV3Qm94PSIwIDAgMTYgMTYiIHZlcnNpb249IjEuMSIgYXJpYS1oaWRkZW49InRydWUiPjxwYXRoIGZpbGwtcnVsZT0iZXZlbm9kZCIgZD0iTTggMEMzLjU4IDAgMCAzLjU4IDAgOGMwIDMuNTQgMi4yOSA2LjUzIDUuNDcgNy41OS40LjA3LjU1LS4xNy41NS0uMzggMC0uMTktLjAxLS44Mi0uMDEtMS40OS0yLjAxLjM3LTIuNTMtLjQ5LTIuNjktLjk0LS4wOS0uMjMtLjQ4LS45NC0uODItMS4xMy0uMjgtLjE1LS42OC0uNTItLjAxLS41My42My0uMDEgMS4wOC41OCAxLjIzLjgyLjcyIDEuMjEgMS44Ny44NyAyLjMzLjY2LjA3LS41Mi4yOC0uODcuNTEtMS4wNy0xLjc4LS4yLTMuNjQtLjg5LTMuNjQtMy45NSAwLS44Ny4zMS0xLjU5LjgyLTIuMTUtLjA4LS4yLS4zNi0xLjAyLjA4LTIuMTIgMCAwIC42Ny0uMjEgMi4yLjgyLjY0LS4xOCAxLjMyLS4yNyAyLS4yNy42OCAwIDEuMzYuMDkgMiAuMjcgMS41My0xLjA0IDIuMi0uODIgMi4yLS44Mi40NCAxLjEuMTYgMS45Mi4wOCAyLjEyLjUxLjU2LjgyIDEuMjcuODIgMi4xNSAwIDMuMDctMS44NyAzLjc1LTMuNjUgMy45NS4yOS4yNS41NC43My41NCAxLjQ4IDAgMS4wNy0uMDEgMS45My0uMDEgMi4yIDAgLjIxLjE1LjQ2LjU1LjM4QTguMDEzIDguMDEzIDAgMCAwIDE2IDhjMC00LjQyLTMuNTgtOC04LTh6Ij48L3BhdGg+PC9zdmc+Cg=="

/***/ }),

/***/ 304:
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	exports.__esModule = true;
	
	var _react = __webpack_require__(2);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _NavBar = __webpack_require__(303);
	
	var _NavBar2 = _interopRequireDefault(_NavBar);
	
	var _Footer = __webpack_require__(302);
	
	var _Footer2 = _interopRequireDefault(_Footer);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function Template() {
	  var _ref = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {},
	      location = _ref.location,
	      children = _ref.children;
	
	  var pathname = location.pathname;
	
	
	  return _react2.default.createElement(
	    'div',
	    { className: 'w-100' },
	    _react2.default.createElement(_NavBar2.default, { linkable: pathname !== '/' }),
	    children(),
	    _react2.default.createElement(_Footer2.default, null)
	  );
	}
	
	exports.default = Template;
	module.exports = exports['default'];

/***/ })

});


// WEBPACK FOOTER //
// component---src-layouts-index-jsx-6735c8a3b50856b25adc.js